export const Buy = 'Buy';
export const Sell = 'Sell';